import React from 'react'

const Data = () => {
  return (
    <div className='home_data ' >
      <h1 className='home_title'>
        Mohammad Kaif 
        {/* img */}
      </h1>
      <h3 className="home_subtitle">
        Web Developer
      </h3>
      <p className="home_description">
I'm  creative wev developer based in Maharashtra,India and I'm passionate and dedicated to my work. 
      </p>
      <a href="#contact" className="button button--flex">
         Say Hello <i class="fa-solid fa-paper-plane"></i>
      </a>
    </div>
  )
}

export default Data
